import { applyMiddleware, createStore, Store } from "redux";
import createSagaMiddleware from "redux-saga";
import { createLogger } from "redux-logger";
import { composeWithDevTools } from "@redux-devtools/extension";
import rootSaga from "./sagas";
import rootReducer from "./reducers";

export default function configureStore(initialState?: any): Store {
  try {
    const sagaMiddleware = createSagaMiddleware();
    const middlewares = [sagaMiddleware];

    if (process.env.NODE_ENV === "development") {
      const logger = createLogger({
        collapsed: true,
        diff: true,
      });
      middlewares.push(logger);
    }

    // Ensure rootReducer is a function
    if (typeof rootReducer !== "function") {
      throw new Error(
        `Expected the root reducer to be a function. Instead, received: '${
          rootReducer === null ? "null" : typeof rootReducer
        }'`
      );
    }

    const store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(...middlewares)));

    sagaMiddleware.run(rootSaga);

    if (import.meta.hot) {
      import.meta.hot.accept("./reducers/index", (newModule) => {
        if (newModule) {
          store.replaceReducer(newModule.default);
        }
      });
    }

    return store;
  } catch (error) {
    console.error("Failed to configure store:", error);
    throw error;
  }
}
